<template>
  <div class="signup-container">
    <v-card
      width="550"
      style="padding: 70px 50px; border-radius: 14px"
      variant="outlined"
      :style="{
        borderBottom: '5px solid #272727',
        borderLeft: '2px solid #272727',
        borderTop: '2px solid #272727',
        borderRight: '5px solid #272727',
      }"
      class="bg-white"
    >
      <div class="logo">
        <v-img
          width="40"
          height="40"
          :src="require('@/assets/logo/logo_dark.svg')"
          contain
        ></v-img>
        <!-- <b style="font-size: 18px">Stix</b> -->
      </div>

      <div class="sub-container form">
        <div>
          <h1
            :style="{
              fontSize: $vuetify.display.smAndDown ? '35px' : '40px',
            }"
            class="mb-4"
          >
            Verify your email
          </h1>
          <p>
            A verification email has been sent to your inbox. Click the button
            in the e-mail to continue.
          </p>

          <v-btn
            elevation="0"
            height="50"
            class="mt-8"
            variant="flat"
            color="success"
            :style="{
              borderBottom: '3px solid #272727',
              borderLeft: '1px solid #272727',
              borderTop: '1px solid #272727',
              borderRight: '3px solid #272727',
              borderRadius: '8px',
            }"
            block
            :disabled="resendTimer > 0"
            @click="handleResend"
          >
            <template v-if="resendTimer > 0">
              Resend in {{ resendTimer }}
            </template>
            <template v-else> Resend e-mail </template>
          </v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";

export default {
  data() {
    return {
      email: "",
      overlay: false,
      resendTimer: 0,
    };
  },
  methods: {
    async handleResend() {
      const resendVerificationEmail = httpsCallable(
        functions,
        "resendVerificationEmail",
      );
      const res = await resendVerificationEmail();
      console.log(res.data);
      this.$store.commit("setNotification", {
        show: true,
        text: "Verification email sent. Check your inbox.",
        type: "info",
      });
      this.resendTimer = 10;
    },
    startResendTimer() {
      this.resendTimer = 10;
      const timer = setInterval(() => {
        this.resendTimer--;
        if (this.resendTimer <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
  },
  mounted() {
    this.startResendTimer();
  },
};
</script>

<style scoped lang="scss">
.signup-container {
  height: 100vh;

  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;

  .logo {
    display: flex;
    flex-direction: column;
    margin-bottom: 10%;
    gap: 8px;
    width: 50px;
    align-items: center;
  }

  .sub-container {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    max-width: 450px;

    &.form {
      justify-content: flex-start;
    }
  }
}
</style>
